<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 2376 2622"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <g transform="matrix(0.995286,0,0,0.997277,3.36271,7.13515)">
      <g id="tshirt_4_back">
        <g
          id="primary-colour"
          transform="matrix(19.4648,0,0,19.4319,-12515.7,2875.35)"
        >
          <path
            d="M684.313,-143.458C683.98,-143.588 683.759,-143.664 683.665,-143.669C684.5,-144.802 688.443,-147.502 688.443,-147.502C698.788,-148.063 709.15,-148.164 719.536,-147.597L720.128,-147.352L723.907,-143.715C723.907,-143.715 723.844,-143.679 723.723,-143.613L724.166,-143.605C724.166,-143.605 744.479,-136.387 749.12,-134.897C753.762,-133.408 756.51,-122.843 757.097,-121.031C757.321,-119.262 759.107,-106.477 759.538,-102.917C759.969,-99.357 761.396,-86.931 761.388,-86.08C760.052,-85.134 755.781,-84.25 750.863,-83.822C745.945,-83.393 741.64,-85.402 741.105,-85.788C740.673,-86.44 740.145,-88.553 739.936,-89.262C739.67,-88.371 738.719,-82.082 738.472,-79.402C738.811,-76.472 739.634,-44.489 739.613,-42.735C739.592,-40.98 739.928,-33.351 740.138,-31.764C740.348,-30.178 740.582,-20.318 740.646,-19.473C738.7,-16.701 735.932,-16.53 725.887,-14.638C715.842,-12.746 702.614,-13.422 698.442,-13.488C694.271,-13.554 687.004,-14.61 679.51,-15.251C672.016,-15.892 667.806,-18.902 667.109,-19.698C667.348,-23.189 668.073,-45.573 668.174,-49.569C668.276,-53.566 668.841,-69.096 669.081,-72.834C669.322,-76.572 669.172,-80.948 668.715,-84.141C668.258,-87.333 667.813,-89.062 667.813,-89.062C667.813,-89.062 667.324,-86.986 667.005,-85.997C660.4,-83.465 654.317,-84.26 650.896,-84.751C647.474,-85.242 647.252,-85.829 646.738,-86.589C646.738,-88.901 649.074,-105.516 649.636,-110.936C650.197,-116.355 649.61,-110.601 650.849,-119.85C652.088,-129.099 657.747,-134.193 658.222,-134.439C662.492,-136.69 678.962,-142.037 678.962,-142.037L683.842,-143.446L684.313,-143.458Z"
            :style="{
              fill: productColors.primary_1.value,
              transition: 'all 500ms',
            }"
          />
        </g>
        <g
          id="secondary-colour"
          transform="matrix(19.4648,0,0,19.4319,2299.66,117.138)"
        >
          <path
            d="M0.124,55.737C0.094,55.427 -3.157,24.782 -4.9,19.052C-6.769,12.904 -8.847,9.406 -11.486,7.822L-11.596,7.752C-11.676,7.702 -11.756,7.662 -11.836,7.612C-11.856,7.602 -11.886,7.582 -11.906,7.572C-12.026,7.512 -12.146,7.442 -12.276,7.392C-12.416,7.322 -12.566,7.262 -12.716,7.202C-13.066,7.072 -13.636,6.862 -14.366,6.602C-14.546,6.532 -14.736,6.462 -14.946,6.392C-17.356,5.522 -21.23,4.1 -25.05,2.74C-25.69,2.52 -26.32,2.3 -26.95,2.07C-27.27,1.96 -27.59,1.84 -27.91,1.73C-28.22,1.62 -28.53,1.51 -28.84,1.4C-29.54,1.16 -30.22,0.92 -30.88,0.68C-31.28,0.54 -31.67,0.41 -32.05,0.27C-33.77,-0.34 -35.28,-0.87 -36.41,-1.27C-36.63,-1.35 -36.84,-1.42 -37.03,-1.49L-57.231,-1.833L-77.27,-1.49C-77.46,-1.42 -77.67,-1.35 -77.89,-1.27C-78.45,-1.07 -79.151,-1.002 -79.871,-0.742C-80.281,-0.602 -80.711,-0.452 -81.171,-0.292C-81.511,-0.172 -81.861,-0.042 -82.231,0.088C-82.671,0.238 -83.131,0.398 -83.601,0.568C-85.401,1.198 -87.307,1.931 -89.257,2.621C-89.577,2.741 -89.887,2.851 -90.207,2.961C-91.177,3.311 -92.147,3.651 -93.067,3.981C-93.637,4.181 -94.187,4.371 -94.717,4.561C-96.477,5.191 -98.269,5.81 -99.489,6.25C-99.699,6.32 -99.889,6.39 -100.069,6.46C-100.799,6.72 -101.369,6.93 -101.719,7.06C-102.009,7.17 -102.289,7.3 -102.569,7.46C-102.579,7.46 -102.589,7.46 -102.599,7.47C-102.679,7.52 -102.759,7.56 -102.839,7.61L-102.949,7.68C-102.949,7.68 -102.959,7.68 -102.959,7.69C-105.579,9.33 -107.711,13.064 -109.481,18.624C-111.291,24.334 -114.307,55.25 -114.337,55.56L-114.357,55.71L-114.217,55.76C-114.167,55.79 -109.328,57.811 -103.978,57.811C-103.448,57.811 -102.714,57.726 -102.184,57.686C-96.274,57.186 -94.571,55.942 -94.481,55.892L-94.421,55.852L-93.704,53.282C-93.724,53.136 -93.76,53.001 -93.785,52.86C-94.528,48.643 -95.265,45.002 -96.079,39.542L-96.079,39.492C-96.129,38.672 -96.159,37.852 -96.169,37.012C-96.269,30.832 -95.02,24.01 -91.69,17.83C-88.47,11.85 -85.19,7.32 -78.74,4.29C-70.13,0.24 -44.17,0.24 -35.56,4.29C-29.11,7.32 -25.83,11.85 -22.61,17.83C-19.28,24.01 -18.29,30.58 -18.39,36.76C-18.4,37.6 -18.43,38.42 -18.48,39.24L-18.48,39.29C-19.616,45.108 -20.129,48.397 -20.989,52.487C-21.019,52.627 -21.049,52.757 -21.079,52.887L-19.986,56.167C-19.896,56.217 -17.896,57.447 -11.986,57.947C-11.456,57.987 -10.916,58.007 -10.386,58.007C-5.036,58.007 -0.046,55.967 0.004,55.937L0.144,55.887L0.124,55.737Z"
            :style="{
              fill: productColors.primary_2.value,
              transition: 'all 500ms',
              fillRule: 'nonzero',
            }"
          />
        </g>
        <rect
          id="logo-mask-1"
          x="716.231"
          y="589.85"
          width="946.655"
          height="1014.17"
          style="fill: none"
        />
        <use
          id="full-back-logo"
          :xlink:href="`#backFull${id}`"
          x="410"
          y="330"
          width="460px"
          height="514px"
          transform="matrix(1.71038,0,0,1.71038,503.522,577.002)"
        />
        <rect
          id="logo-mask-2"
          x="713.936"
          y="679.36"
          width="948.128"
          height="440.115"
          style="fill: none"
        />
        <use
          id="back-centre-logo"
          :xlink:href="`#backCenter${id}`"
          x="3750"
          y="3800"
          width="943px"
          height="306px"
          transform="matrix(1,0,0,1,-2558.56,-2895.51)"
        />

        <!--        <rect-->
        <!--          id="logo-mask-3"-->
        <!--          x="1074.65"-->
        <!--          y="264.884"-->
        <!--          width="236.764"-->
        <!--          height="124.687"-->
        <!--          style="fill: none"-->
        <!--        />-->
        <!--        <clipPath id="_clip3">-->
        <!--          <rect x="750" y="200" width="800" height="500" />-->
        <!--        </clipPath>-->

        <g clip-path="url(#_clip3)">
          <use
            id="under-back-logo"
            :xlink:href="`#backUpper${id}`"
            x="1550"
            y="850"
            width="300px"
            height="136px"
            transform="matrix(0.794512,0,0,0.794512,-47.2027,-287.969)"
          />
        </g>
        <g
          v-if="activePlayer"
          id="number-mask"
          transform="matrix(1.00273,0,0,1.00273,-3.2435,-7.15463)"
        >
          <path
            d="M423.117,829.801l1514.32,0.236l-84.755,495.828l36.699,1168.85c-81.026,146.564 -1119.53,169.825 -1415.06,10.812l36.056,-1178.61l-87.26,-497.116Z"
            style="fill: none"
          />
          <clipPath id="_clip1">
            <path
              d="M423.117,829.801l1514.32,0.236l-84.755,495.828l36.699,1168.85c-81.026,146.564 -1119.53,169.825 -1415.06,10.812l36.056,-1178.61l-87.26,-497.116Z"
            />
          </clipPath>
          <g clip-path="url(#_clip1)">
            <g
              id="player-number"
              serif:id="player number"
              transform="matrix(0.997277,0,0,0.997277,569.2,1454.36)"
            >
              <text
                text-anchor="middle"
                x="600"
                :y="`${activePlayer.playerNumberBackVerticalPosition * 10}px`"
                :style="{
                  fontFamily: details.fontFamily,
                  fontSize: `${activePlayer.playerNumberBackSize * 10}px`,
                  fill: details.fontColor.value,
                }"
              >
                {{ activePlayer.number }}
              </text>
            </g>
          </g>
        </g>
        <g
          v-if="activePlayer"
          id="player-mask"
          transform="matrix(1.00273,0,0,1.00273,-3.2435,-7.15463)"
        >
          <path
            d="M2010.14,499.977L348.109,499.977L410.018,799.45L1943.88,799.45L2010.14,499.977Z"
            style="fill: none"
          />
          <clipPath id="_clip2">
            <rect x="350" y="0" width="2000" height="1100" style="fill: none" />
          </clipPath>
          <g clip-path="url(#_clip2)">
            <g
              id="player-name"
              serif:id="player name"
              transform="matrix(0.997277,0,0,0.997277,780.994,738.7)"
            >
              <text
                text-anchor="middle"
                x="400"
                :y="`${activePlayer.nameBackVerticalPosition * 7.1 - 360}`"
                :style="{
                  fontFamily: details.fontFamily,
                  fontSize: `${activePlayer.nameSize * 10}`,
                  fill: details.fontColor.value,
                }"
              >
                {{ activePlayer.name }}
              </text>
            </g>
          </g>
        </g>
        <g
          id="outline"
          transform="matrix(19.4648,0,0,19.4319,-5900.53,2830.92)"
        >
          <path
            d="M348.314,-145.458C348.354,-145.537 348.432,-145.59 348.522,-145.596C358.878,-146.246 369.225,-146.162 379.588,-145.596C379.688,-145.59 379.823,-145.549 379.982,-145.466C380.269,-145.317 380.669,-145.021 381.112,-144.654C381.633,-144.221 382.216,-143.687 382.748,-143.183C383.551,-142.423 384.235,-141.731 384.406,-141.557C385.516,-141.166 403.214,-134.92 408.426,-133.029C410.609,-132.237 412.236,-130.582 413.484,-128.598C415.323,-125.675 416.337,-122.036 417.134,-119.48C418.455,-115.241 421.385,-86.518 421.682,-83.665C421.694,-83.558 421.635,-83.456 421.537,-83.411C410.994,-78.626 401.009,-83.072 401.009,-83.072C400.943,-83.101 400.893,-83.157 400.872,-83.226C400.872,-83.226 400.39,-84.77 400.026,-85.814C399.729,-83.945 399.206,-79.848 398.923,-77.504C398.923,-77.502 398.923,-77.499 398.922,-77.497C398.508,-74.739 400.837,-18.364 400.976,-17.136C400.983,-17.073 400.965,-17.009 400.927,-16.958C399.842,-15.519 397.367,-14.328 393.932,-13.404C388.871,-12.042 381.708,-11.228 373.924,-10.908C360.316,-10.349 344.808,-11.299 335.333,-13.451C331.212,-14.387 328.223,-15.567 326.985,-16.928C326.941,-16.976 326.918,-17.039 326.92,-17.105C326.92,-17.105 329.028,-75.403 329.075,-77.478C329.11,-79.02 328.25,-83.279 327.814,-85.324C327.671,-84.729 327.475,-84.019 327.251,-83.497C327.225,-83.438 327.178,-83.39 327.118,-83.365C316.604,-78.944 307.394,-83.255 306.632,-83.562C306.529,-83.603 306.466,-83.708 306.477,-83.819C306.805,-87.073 309.174,-106.128 310.19,-114.789C310.803,-120.023 312.364,-124.752 314.281,-128.057C315.582,-130.298 317.053,-131.886 318.5,-132.56C318.502,-132.561 318.504,-132.562 318.506,-132.563C321.67,-133.936 341.755,-140.994 343.608,-141.481C345.167,-143.515 347.852,-145.083 348.314,-145.458ZM318.057,-131.737C316.9,-130.967 315.755,-129.6 314.714,-127.806C312.825,-124.55 311.291,-119.888 310.686,-114.731C309.689,-106.223 307.384,-87.68 306.993,-83.952C308.473,-83.322 317.068,-79.728 326.83,-83.787C327.222,-84.753 327.516,-86.279 327.562,-86.521C324.899,-101.464 321.713,-116.541 318.057,-131.737ZM328.071,-86.504C328.222,-85.821 329.619,-79.443 329.575,-77.467C329.529,-75.442 327.522,-19.92 327.424,-17.19C328.661,-15.907 331.533,-14.827 335.444,-13.939C344.886,-11.794 360.341,-10.851 373.903,-11.408C381.645,-11.726 388.769,-12.533 393.802,-13.887C397.037,-14.757 399.4,-15.839 400.47,-17.184C400.265,-20.133 398.022,-74.79 398.427,-77.566C398.775,-80.445 399.483,-85.944 399.7,-86.802C399.701,-86.809 399.704,-86.816 399.706,-86.823C402.376,-101.794 405.57,-116.898 409.236,-132.123C408.923,-132.289 408.596,-132.435 408.255,-132.559C403.048,-134.448 385.371,-140.687 384.242,-141.085C373.323,-141.592 354.891,-141.528 343.879,-141.044C343.849,-141.026 343.816,-141.015 343.78,-141.011C343.054,-140.933 321.96,-133.516 318.708,-132.106C318.641,-132.075 318.574,-132.041 318.507,-132.006C322.187,-116.723 325.391,-101.561 328.067,-86.533C328.069,-86.524 328.07,-86.514 328.071,-86.504ZM400.204,-86.767C400.483,-86.107 401.154,-83.993 401.315,-83.485C402.377,-83.044 411.511,-79.497 421.166,-83.793C420.784,-87.489 417.95,-115.18 416.657,-119.331C415.87,-121.854 414.876,-125.447 413.061,-128.332C412.164,-129.758 411.066,-131.011 409.688,-131.863C408.722,-127.85 407.789,-123.845 406.89,-119.849C404.394,-108.754 402.158,-97.724 400.204,-86.767ZM383.646,-141.612C383.004,-142.253 381.782,-143.447 380.793,-144.269C380.439,-144.563 380.116,-144.808 379.863,-144.96C379.734,-145.037 379.634,-145.093 379.561,-145.097C369.256,-145.66 358.966,-145.745 348.669,-145.104C348.66,-145.095 348.65,-145.086 348.639,-145.078C348.233,-144.742 345.879,-143.378 344.318,-141.563C355.181,-142.021 372.804,-142.083 383.646,-141.612Z"
            style="fill: rgb(128, 128, 128)"
          />
        </g>
        <g
          v-if="cheetaLogo.position === 'back'"
          id="cheeta-logo"
          transform="matrix(2.97774,0,0,2.97774,1058.19,128.807)"
        >
          <path
            d="M11.062,7.23l0.679,-2.689l-3.915,0l-0.678,2.689l-1.072,4.252l-0.678,2.687l3.916,-0l0.677,-2.687l4.769,0l-1.113,4.413c-0.375,1.485 -1.71,2.526 -3.242,2.526l-6.555,0c-2.178,0 -3.775,-2.049 -3.242,-4.16l2.886,-11.446c0.374,-1.485 1.71,-2.525 3.241,-2.525l6.557,0c2.178,0 3.774,2.049 3.242,4.161l-0.701,2.78l-4.771,-0.001Zm16.353,-6.745l4.768,0l-2.205,8.551l-0.617,2.446l-1.749,6.94l-4.77,0l1.751,-6.94l-3.916,0l-1.75,6.941l-4.769,0l4.572,-17.938l4.769,0l-1.75,6.745l3.915,0l1.751,-6.745Zm9.614,4.056l-0.678,2.689l6.766,0l-1.072,4.252l-6.766,0l-0.679,2.687l6.766,-0l-1.072,4.253l-11.533,-0l4.571,-17.937l11.536,-0l-1.073,4.056l-6.766,-0Zm12.577,0l-0.68,2.689l6.766,0l-1.071,4.252l-6.766,0l-0.678,2.687l6.766,-0l-1.073,4.253l-11.534,-0l4.572,-17.937l11.535,-0l-1.071,4.056l-6.766,-0Zm22.235,-4.056l-1.072,4.056l-4.215,0l-3.499,13.881l-4.769,0l3.5,-13.881l-4.471,0l1.072,-4.056l13.454,0Zm0.511,2.329c0.375,-1.485 1.712,-2.525 3.243,-2.525l6.556,0c2.177,0 3.774,2.048 3.242,4.16l-3.522,13.972l-4.77,0l1.071,-4.252l0.679,-2.687l-3.916,0l-0.677,2.687l-1.071,4.252l-4.77,0l3.936,-15.607l-0.001,0Zm7.57,4.416l0.678,-2.689l-3.916,0l-0.678,2.689l3.916,0Zm-62.945,20.44l1.99,-7.811l4.646,0l-0.271,1.024l-3.313,0l-0.574,2.274l3.308,0l-0.282,1.12l-3.308,0l-0.575,2.274l3.31,0l-0.282,1.119l-4.649,0Zm-5.147,-0l1.712,-6.787l-2.178,-0l0.27,-1.024l5.586,-0l-0.271,1.024l-2.065,-0l-1.711,6.787l-1.343,-0Zm15.767,0.028l0.374,-1.482l0.482,-1.911l-2.905,-0l-0.855,3.394l-1.342,-0l1.774,-7.034c0.129,-0.514 0.59,-0.873 1.12,-0.873l3.206,-0c0.358,-0 0.69,0.162 0.911,0.445c0.22,0.283 0.296,0.645 0.209,0.992l-1.631,6.47l-1.343,-0.001Zm-1.767,-4.513l2.905,0l0.573,-2.275l-2.905,0l-0.573,2.275Zm27.998,4.491l1.99,-7.81l4.644,0l-0.27,1.024l-3.313,0l-0.573,2.274l3.308,0l-0.282,1.119l-3.308,0l-0.575,2.274l3.309,0l-0.282,1.119l-4.648,0Zm10.608,0.029l0.373,-1.483l0.483,-1.911l-2.906,0l-0.854,3.394l-1.343,0l1.775,-7.034c0.129,-0.513 0.589,-0.873 1.12,-0.873l3.205,0c0.359,0 0.691,0.162 0.912,0.445c0.22,0.284 0.296,0.645 0.209,0.992l-1.631,6.47l-1.343,0Zm-1.767,-4.513l2.904,0l0.574,-2.274l-2.905,0l-0.573,2.274Zm-18.914,4.471c-0.359,0 -0.691,-0.162 -0.912,-0.445c-0.221,-0.283 -0.296,-0.645 -0.209,-0.992l1.63,-6.36l1.34,0l-1.711,6.678l2.905,0l1.712,-6.678l1.34,0l-1.711,6.678l2.905,0l1.711,-6.678l1.343,0l-1.992,7.797l-8.351,0Zm-4.519,0l1.711,-6.677l-2.905,0l-1.712,6.677l-1.341,0l1.712,-6.677l-2.905,0l-1.711,6.677l-1.343,0l1.991,-7.797l8.353,0c0.359,0 0.691,0.162 0.912,0.445c0.22,0.284 0.296,0.645 0.209,0.992l-1.63,6.36l-1.341,0Zm32.222,0.046l-0.227,-3.392l-1.654,0l-0.856,3.394l-1.342,0l1.23,-4.877l0.332,-1.314l0.433,-1.717l4.105,0c0.359,0 0.691,0.162 0.912,0.445c0.22,0.284 0.296,0.645 0.209,0.992l-0.557,2.202c-0.116,0.462 -0.512,0.809 -0.985,0.864l-0.455,0.053l0.224,3.35l-1.369,0Zm-1.6,-4.511l2.906,-0l0.573,-2.273l-2.904,-0l-0.575,2.273Z"
            :style="{
              fill: cheetaLogo.color.value,
              transition: 'all 500ms',
              fillRule: 'nonzero',
            }"
          />
        </g>
      </g>
    </g>
    <defs>
      <image
        v-if="backFullLogo"
        :width="`${backFullLogo.size}%`"
        :height="`${backFullLogo.size}%`"
        :id="`backFull${id}`"
        :href="backFullLogo.path"
        :style="{
          transform: `translate(-${
            backFullLogo.size / 2 - backFullLogo.offsetX
          }% , ${-backFullLogo.size / 2 + backFullLogo.offsetY}%)`,
          transformOrigin: `center center`,
        }"
      />
      <image
        v-if="backCenterLogo"
        :width="`${backCenterLogo.size}%`"
        :height="`${backCenterLogo.size}%`"
        :id="`backCenter${id}`"
        :href="backCenterLogo.path"
        :style="`transform: translate(-${backCenterLogo.size / 2}%, -${
          backCenterLogo.size / 2
        }%)`"
      />
      <image
        v-if="backUpperLogo"
        :width="`${backUpperLogo.size}%`"
        :height="`${backUpperLogo.size}%`"
        :id="`backUpper${id}`"
        :href="backUpperLogo.path"
        :style="{
          transform: `translate(-${
            backUpperLogo.size / 2 - backUpperLogo.offsetX
          }% , ${-backUpperLogo.size / 2 + backUpperLogo.offsetY}%)`,
          transformOrigin: `center center`,
        }"
      />
      <svg:style>
        {{ fontFace }}
      </svg:style>
    </defs>
  </svg>
</template>

<script>
import { getFontFace } from "@/assets/fonts/fontsBase64";
import { computed } from "vue";
export default {
  name: "T_shirt_4_back",
  props: ["productColors", "logo", "activePlayer", "cheetaLogo", "details"],
  setup(props) {
    const id = Math.floor(Math.random() * 10000).toString();
    const fontFace = computed(() => getFontFace(props.details.fontFamily));

    const backFullLogo = computed(() => props.logo.backFull);
    const backCenterLogo = computed(() => props.logo.backCenter);
    const backUpperLogo = computed(() => props.logo.backUpper);

    return {
      id,
      fontFace,
      backFullLogo,
      backCenterLogo,
      backUpperLogo,
    };
  },
};
</script>
